import { render, staticRenderFns } from "./metrics_rubric_breakdown.vue?vue&type=template&id=fa4566f2&scoped=true&"
import script from "./metrics_rubric_breakdown.vue?vue&type=script&lang=js&"
export * from "./metrics_rubric_breakdown.vue?vue&type=script&lang=js&"
import style0 from "./metrics_rubric_breakdown.vue?vue&type=style&index=0&id=fa4566f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4566f2",
  null
  
)

export default component.exports